// Import Shaka Player default control styles to ensure proper styling without needing external CDN links
import 'shaka-player/dist/controls.css';
// Import library specific (Tailwind-based) overrides after the base Shaka styles so that our custom
// styles take precedence.
import './styles.css';
export { Player } from './Player';
export { Video } from './Video';
export { Event } from './Event';
export { CreativeWork } from './CreativeWork';
export { QueryProvider, queryClient } from './QueryProvider';
export { SkipBackIcon, SkipForwardIcon, BigPlayIcon } from './icons';
export { PlayerProvider, usePlayerStore, usePlayerStoreApi } from './store/PlayerStore';
export type { PlayerProps, PlayerEvents, IconSizes, TimeUpdateData } from './types';
export type { PlayerStore, PlayerStoreState, PlayerStoreActions } from './store/PlayerStore';
export type { VideoProps } from './Video';
export type { EventProps } from './Event';
export type { CreativeWorkProps } from './CreativeWork';
export type { VideoData, ConcurrencySession, ConcurrencyServerMessage, ConcurrencyClientMessage } from './api/video';
export { ConcurrencyConnectionState } from './api/video';
export type { EventData, EventsSortDirection } from './api/event';
export type { CreativeWorkData, CreativeWorksSortDirection } from './api/creative-work';
// Concurrency session hook types (for custom integrations)
export type { SessionStartedInfo, ConcurrencySessionState, UseConcurrencySessionOptions } from './hooks/useConcurrencySession';
export { useConcurrencySession } from './hooks/useConcurrencySession';
// Device ID utility (for custom integrations)
export { getDeviceId, clearDeviceId } from './utils/deviceId'; 